import type { Renderer } from 'pixi.js';
import type { DioramaConfig } from '../../../app/state/diorama/dioramaState';
import { DioramaShareLayout } from '../../../../layouts/dioramas/DioramaShareLayout';
import { DioramaView } from './DioramaView';

export async function createDioramaShareImageBase64(renderer: Renderer, config: DioramaConfig): Promise<string> {
  const { root, dioramaSlot } = new DioramaShareLayout();

  new DioramaView({
    config,
    progress: Infinity,
    isLocked: false,
    hideRays: true,
    hideBackground: true,
  }).props({
    parent: dioramaSlot,
  });

  const result = renderer.extract.base64(root);

  root.destroy({ children: true });

  return result;
}
